class Axis {

	constructor() {
		this.config = {
			dataAccessor: d => 0,
			min: null,
			max: null,
			tickValues: null,
			range: null,
			formatter: value => value,
			tooltipFormatter: value => value
		};
	}

	data(data) {
		this.config.dataAccessor = data;
		return this;
	}

	tickValues(tickValues) {
		this.config.tickValues = tickValues;
		return this;
	}

	formatter(formatter) {
		this.config.formatter = formatter;
		return this;
	}

	tooltipFormatter(formatter) {
		this.config.tooltipFormatter = formatter;
		return this;
	}

	range(range) {
		this.config.range = range;
		return this;
	}

}

export function xAxis() {
	return new Axis();
}



// WEBPACK FOOTER //
// ./utils/panelgraph/components/axis-x.js